import type { FC } from "react";
import { createContext, useContext } from "react";

import type { RewardOption } from "../hooks";
import { useRewardOptions } from "../hooks";

export type RewardContextState = {
  rewardOptions: RewardOption[];
  refreshRewards: () => Promise<void>;
};

const RewardContext = createContext<RewardContextState>({
  rewardOptions: [],
  refreshRewards: Promise.resolve,
});

export const RewardProvider: FC<{ children?: React.ReactNode }> = ({ children }) => {
  const { rewardOptions, refreshRewardOptions } = useRewardOptions();
  const refreshRewards = async () => {
    await refreshRewardOptions();
  };
  return <RewardContext.Provider value={{ rewardOptions, refreshRewards }}>{children}</RewardContext.Provider>;
};

export const useRewards = () => useContext(RewardContext);
